import { RetouchPanel } from './RetouchPanel';
import { replaceImage } from './imageSwap';

// Designer: retouch the photo itself; effects are reset because they were computed from the old version.
export const RetouchSheet = ({ editor, o }) => <div data-testid="sheet-retouch">
  <RetouchPanel assetId={o.assetId} original={o.retouchOriginal || o.assetId}
    onApply={r => replaceImage(editor, o, r, { name: o.name, retouchOriginal: o.retouchOriginal || o.assetId, effect: 'none', aiGenerated: o.aiGenerated })}
    onReset={() => replaceImage(editor, o, { id: o.retouchOriginal, width: o.baseW, height: o.baseH }, { name: o.name, retouchOriginal: undefined, effect: 'none', aiGenerated: o.aiGenerated })} />
</div>;
